import React from 'react'

function AuctionReport() {
  return (
    <div>AuctionReport</div>
  )
}

export default AuctionReport